import {ChangeDetectorRef, Component, ElementRef, forwardRef, HostListener} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractInput} from "../../../framework/abstract-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIEditTextareaInputComponent),
            multi: true
        }
    ],
    selector: "fui-edit-textarea-input",
    styleUrls: ["./edit-textarea-input.component.scss"],
    templateUrl: "./edit-textarea-input.component.html",
    standalone: false
})
export class FUIEditTextareaInputComponent extends FUIAbstractInput {

    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    /**
     * Perform events after a click on the host
     * @param element
     */
    @HostListener("click")
    override click(): void {
        this.focus();
    }
}
